import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import PortForm from '../components/PortForm';
import PortResponse from '../components/PortResponse';
import SubNav from '../components/SubNav';
import { portModify, portInfo } from '../actions/subs';
import {
  getSubmitStatus,
  getPortInfo,
  getPortModifyResponse,
} from '../reducers';
import subPage from '../decorators/subPage';
import { prettyKey } from '../helpers/formatters';

const mapPortInfoToValues = ({ mdn, port_details }) => ({
  remark: '',
  mdn,
  port_details,
});

class PortModify extends Component {
  componentDidMount() {
    this.fetchPortInfo();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.subId !== this.props.subId) {
      this.fetchPortInfo();
    }
    if (oldProps.port !== this.props.port) {
      this.initializeForm();
    }
  }

  fetchPortInfo() {
    const { portInfo, subId } = this.props;
    portInfo(subId);
  }

  initializeForm() {
    const { port, initialize } = this.props;
    initialize('port', port, true);
  }

  render() {
    const { subId, sub, portModify, portResponse, port, ...props } = this.props;
    if (!sub) {
      return <div>Loading</div>;
    }

    return (
      <div>
        <h1>Update Port</h1>
        <SubNav />
        <br />
        {port && (
          <div className="row">
            <div className="col-sm-5">
              <table className="table">
                <tbody>
                  {['mdn_type'].map((attr) => (
                    <tr key={attr}>
                      <td>
                        <b>{prettyKey(attr)}:</b>
                      </td>
                      <td>{port[attr]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        <PortForm onSubmit={(values) => portModify(subId, values)} {...props} />
        <br />
        {portResponse && ['SUCCEEDED', 'FAILED'].includes(props.saveStatus) && (
          <PortResponse data={portResponse} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, { subId }) => ({
  portResponse: getPortModifyResponse(state, subId),
  saveStatus: getSubmitStatus(state, 'port'),
  initialValues:
    getPortInfo(state, subId) && mapPortInfoToValues(getPortInfo(state, subId)),
  port: getPortInfo(state, subId),
});

const mapDispatchToProps = {
  portModify,
  portInfo,
  initialize,
};

PortModify = subPage(connect(mapStateToProps, mapDispatchToProps)(PortModify));

export default PortModify;
